<template>
  <transition appear>
    <div v-if="show" class="info-banner">
      <div class="banner-a">
        <div>
          <h3>Don't miss out!</h3>
          <p>
            Sign up for our newsletter so you can be the first to hear about all
            the exciting things happeing at Kids with Drones!
          </p>
        </div>
        <!-- <input type="email" v-model="email" placeholder="email" /> -->
      </div>
      <div class="banner-b">
        <form
          action="//mc.us10.list-manage.com/subscribe/form-post?u=2a572528465ebc2754a1ae238&amp;id=f377369074&amp;popup=true"
          accept-charset="UTF-8"
          method="post"
          enctype="multipart/form-data"
          data-dojo-attach
        >
          <input type="email" v-model="email" placeholder="email" />
          <button><span>Sign Up!</span></button>
        </form>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'InfoBanner',
  data() {
    return {
      show: false,
      email: ''
    };
  },
  mounted() {
    setTimeout(() => {
      this.show = true;
    }, 2500);
  }
};
</script>

<style lang="scss" scoped>
.info-banner {
  // width: 100%;
  // height: 100px;

  position: absolute;
  // bottom: 20px;
  bottom: 75%;
  left: 0;
  right: 0;
  margin: 0 auto;
  display: flex;
  padding-left: 20vw;
  // justify-content: center;
  text-align: center;
  transform: scale(1);
  opacity: 1;
  transition: 1s cubic-bezier(0, 1.63, 0.07, 0.97);
  // transform: perspective(1);
  // transform: scale3d(1);

  > .banner-a {
    position: absolute;
    // top: 0;
    top: -20px;
    margin-left: -150px;
    display: inline-block;
    background: linear-gradient(#ffffff, #c9f5ff);
    box-shadow: 0 10px 60px #0043a782;
    color: #316dff;
    // padding: 20px 50px;
    padding: 40px 50px;
    border-radius: 100%;
    max-width: 300px;
    // transform: rotateZ(5deg);

    h3 {
      font-size: 30px;
      margin: 0 0 10px;
    }

    p {
      font-size: 20px;
      margin: 0 0 20px;
    }

    > div {
      transform: rotateZ(-5deg);
    }
  }

  .banner-b {
    position: absolute;
    top: 170px;
    margin-left: -40px;
    // transform: rotateZ(-2deg);

    display: inline-block;
    background: linear-gradient(#ffffff, #c9f5ff);
    box-shadow: 0 10px 60px #0043a782;
    color: #316dff;
    padding: 60px 50px;
    border-radius: 100%;
    // max-width: 300px;

    > form {
      border-bottom: 2px dotted #9bbbda;
      display: flex;
      padding: 5px;

      input {
        font-size: 20px;
        line-height: 1em;
        border: none;
        // border: 2px solid #8dcfff;
        color: #316dff;
        // padding: 5px 20px;
        padding: 0;
        outline: none !important;
        font-family: 'DayCare';
        // border-radius: 10px;
        // box-shadow: 0 5px 20px #006d9e52;
        background: transparent;
        // border-bottom: 2px solid #9bbbda;
        margin-right: 5px;
      }

      > button {
        font-family: 'DayCare';
        flex-shrink: 0;
        padding: 12px 10px;
        font-size: 18px;
        border-radius: 10px;
        border: none;
        // color: white;
        background: linear-gradient(#84ff76, #23cbdc);
        color: #006d90;

        background: linear-gradient(#0296ff, #28d0d8);
        color: white;

        line-height: 1em;
        transform: scale(1);
        transition: 0.2s cubic-bezier(0.01, 0.85, 0.42, 1.73);

        > span {
          display: block;
          transform: scale(1);
          transition: 0.2s cubic-bezier(0.01, 0.85, 0.42, 1.73);
        }

        &:hover {
          transform: scale(1.15);

          > span {
            transform: scale(1.15);
          }
        }
      }
    }
  }

  &.v-enter,
  &.v-leave-to {
    // height: 0;
    // bottom: -50px;
    transform: scale(0.25);
    opacity: 0;
  }

  &.v-enter-active,
  &.v-leave-active {
    // transition: 0.25s cubic-bezier(0.04, 1.13, 0.02, 1);
  }
}

@keyframes bounceIn {
  from,
  20%,
  40%,
  60%,
  80%,
  to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  20% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1);
    transform: scale3d(1.1, 1.1, 1.1);
  }

  40% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9);
    transform: scale3d(0.9, 0.9, 0.9);
  }

  60% {
    opacity: 1;
    -webkit-transform: scale3d(1.03, 1.03, 1.03);
    transform: scale3d(1.03, 1.03, 1.03);
  }

  80% {
    -webkit-transform: scale3d(0.97, 0.97, 0.97);
    transform: scale3d(0.97, 0.97, 0.97);
  }

  to {
    opacity: 1;
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/InfoBanner.vue